// extracted by mini-css-extract-plugin
export default {"big-title":"NewOrganization_big-title__OB538"};